<template>
  <div class="lms-layout">
    <div class="lms-layout-content">
      <lms-toolbar :actions="actions" v-if="actions.length>0 ||showBackButton"
                   :showBackButton="showBackButton"
                   :backButtonClick="backButtonClick"
                   @toolbarClick="handleClick"></lms-toolbar>
      <div class="lms-layout-content-body m-t">
        <slot name='t-body'>
        </slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
  import subLayout from './subLayout'
  export default {
    mixins: [subLayout],
    name: "lms-layout"
  }
</script>
<style>
  .lms-layout {
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
  }

  .lms-layout-content {
    position: absolute;
    top: 10px;
    right: 10px;
    bottom: 10px;
    left: 10px;
    background: white;
    border-radius: 3px;
    box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.1);
    overflow: auto;
  }

  .lms-layout-content-body {
    position: absolute;
    top: 40px;
    right: 15px;
    bottom: 5px;
    left: 15px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// Layout.vue?78f1d567